(function () {
  if (window.ifMobileQuickAddReady) return;
  window.ifMobileQuickAddReady = true;

  var drawer = null;
  var backdrop = null;
  var activeCard = null;
  var selectedHandle = null;
  var selectedVariantId = null;

  var dragStartY = 0;
  var dragCurrentY = 0;
  var isDragging = false;

  function getHandleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : '';
  }

  function getCurrentProductUrl(card) {
    var link =
      card.querySelector('a[data-pr-href][href*="/products/"]') ||
      card.querySelector('.t4s-full-width-link[href*="/products/"]') ||
      card.querySelector('.t4s-product-title a[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    return link ? link.getAttribute('href') : '';
  }

  function getCurrentHandle(card) {
    return getHandleFromUrl(getCurrentProductUrl(card));
  }

  function getQuickAddData(card) {
    var script = card.querySelector('.if-mobile-quick-add-data');

    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.warn('Quick add JSON could not be parsed', e);
      return null;
    }
  }

  function getQuickAddProduct(data, handle) {
    if (!data || !data.products || !data.products.length) return null;

    return (
      data.products.find(function (item) {
        return item.handle === handle;
      }) ||
      data.products.find(function (item) {
        return item.handle === data.currentHandle;
      }) ||
      data.products[0]
    );
  }

  function buildDrawer() {
    backdrop = document.createElement('div');
    backdrop.className = 'if-mobile-quick-add-backdrop';

    drawer = document.createElement('div');
    drawer.className = 'if-mobile-quick-add';
    drawer.innerHTML = [
      '<div class="if-mobile-quick-add__handle"></div>',
      '<button type="button" class="if-mobile-quick-add__close" aria-label="Close">×</button>',
      '<div class="if-mobile-quick-add__inner"></div>'
    ].join('');

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);

    backdrop.addEventListener('click', closeDrawer);
    drawer.querySelector('.if-mobile-quick-add__close').addEventListener('click', closeDrawer);

    drawer.addEventListener('touchstart', onDragStart, { passive: true });
    drawer.addEventListener('touchmove', onDragMove, { passive: false });
    drawer.addEventListener('touchend', onDragEnd);
  }

  function openDrawer() {
    if (!drawer) buildDrawer();

    drawer.style.transform = '';

    requestAnimationFrame(function () {
      backdrop.classList.add('is-active');
      drawer.classList.add('is-active');
      document.body.classList.add('if-mobile-quick-add-open');
    });
  }

  function closeDrawer() {
    if (!drawer) return;

    backdrop.classList.remove('is-active');
    drawer.classList.remove('is-active');
    drawer.classList.remove('is-dragging');
    drawer.style.transform = '';
    document.body.classList.remove('if-mobile-quick-add-open');
  }

  function onDragStart(event) {
  if (!drawer.classList.contains('is-active')) return;

  dragStartY = event.touches[0].clientY;
  dragCurrentY = dragStartY;

  /*
    Only allow swipe-to-close when the drawer content is already
    scrolled right to the top.
  */
  isDragging = drawer.scrollTop <= 0;

  if (isDragging) {
    drawer.classList.add('is-dragging');
  }
}

function onDragMove(event) {
  if (!isDragging) return;

  dragCurrentY = event.touches[0].clientY;

  var diff = dragCurrentY - dragStartY;

  /*
    If the user swipes up, do not drag the drawer.
    Let the drawer scroll normally.
  */
  if (diff <= 0) {
    drawer.classList.remove('is-dragging');
    drawer.style.transform = '';
    isDragging = false;
    return;
  }

  /*
    If the drawer is no longer at the top, stop the close gesture.
    This lets the user scroll back up through the content/images.
  */
  if (drawer.scrollTop > 0) {
    drawer.classList.remove('is-dragging');
    drawer.style.transform = '';
    isDragging = false;
    return;
  }

  event.preventDefault();

  drawer.style.transform = 'translateY(' + diff + 'px)';
}

function onDragEnd() {
  if (!isDragging) return;

  var diff = dragCurrentY - dragStartY;

  isDragging = false;
  drawer.classList.remove('is-dragging');

  if (diff > 90 && drawer.scrollTop <= 0) {
    closeDrawer();
  } else {
    drawer.style.transform = '';
  }
}

  function formatSizeLabel(size) {
    var raw = String(size || '').trim();
    var key = raw.toUpperCase().replace(/\s+/g, '');

    var map = {
      XXS: 'Extra Extra Small',
      XS: 'Extra Small',
      S: 'Small',
      M: 'Medium',
      L: 'Large',
      XL: 'Extra Large',
      XXL: 'Extra Extra Large',
      XXXL: 'Extra Extra Extra Large',
      OS: 'One Size',
      'O/S': 'One Size',
      ONESIZE: 'One Size',
      SM: 'Small / Medium',
      'S/M': 'Small / Medium',
      'S-M': 'Small / Medium',
      ML: 'Medium / Large',
      'M/L': 'Medium / Large',
      'M-L': 'Medium / Large',
      LXL: 'Large / Extra Large',
      'L/XL': 'Large / Extra Large',
      'L-XL': 'Large / Extra Large',
      XSS: 'Extra Small / Small',
      'XS/S': 'Extra Small / Small',
      'XS-S': 'Extra Small / Small'
    };

    return map[key] || raw;
  }

  function getProductImagesHtml(product) {
    var images = product.images || [];

    if (!images.length) {
      return '<div style="min-width:72%;aspect-ratio:3/4;background:#f6f6f6;"></div>';
    }

    return images.map(function (src) {
      return '<img src="' + escapeAttribute(src) + '" alt="' + escapeAttribute(product.title || '') + '">';
    }).join('');
  }

  function getPriceNumberFromHtml(priceHtml) {
    var text = String(priceHtml || '').replace(/<[^>]*>/g, ' ');
    var matches = text.match(/\$([0-9]+(?:\.[0-9]{1,2})?)/g);

    if (!matches || !matches.length) return 0;

    var prices = matches.map(function (item) {
      return parseFloat(item.replace('$', ''));
    }).filter(Boolean);

    if (!prices.length) return 0;

    return Math.min.apply(null, prices);
  }

  function getAfterpayHtml(priceHtml, modifier) {
  var price = getPriceNumberFromHtml(priceHtml);

  if (!price) return '';

  var instalment = price / 4;

  return (
    '<div class="if-mobile-quick-add__afterpay ' + (modifier || '') + '">' +
      '<span>4 x $' + instalment.toFixed(2) + ' with</span>' +
      '<span class="if-mobile-quick-add__afterpay-logo">afterpay</span>' +
    '</div>'
  );
}

  function getColourHtml(data, activeHandle) {
    if (!data || !data.products || data.products.length <= 1) return '';

    return (
      '<div class="if-mobile-quick-add__colors">' +
        '<div class="color-list">' +
          data.products.map(function (item) {
            var swatchStyle = item.swatchImage
              ? 'background-image:url(' + escapeAttribute(item.swatchImage) + ');'
              : 'background-color:' + escapeAttribute(item.swatchColour || '#ffffff') + ';';

            return (
              '<button ' +
                'type="button" ' +
                'class="color-link if-mobile-quick-add__colour-swatch' + (item.handle === activeHandle ? ' is-active' : '') + '" ' +
                'data-quick-add-handle="' + escapeAttribute(item.handle) + '" ' +
                'aria-label="' + escapeAttribute(item.colour || item.title || '') + '"' +
              '>' +
                '<div class="color-item" style="' + swatchStyle + '"></div>' +
              '</button>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function getUniqueSizes(variants) {
    var seen = {};
    var uniqueSizes = [];

    (variants || []).forEach(function (variant) {
      var size = variant.size;

      if (!size) return;

      if (!seen[size]) {
        seen[size] = {
          size: size,
          id: variant.id,
          available: !!variant.available,
          bestFit: variant.bestFit || ''
        };

        uniqueSizes.push(seen[size]);
      } else if (variant.available && !seen[size].available) {
        seen[size].id = variant.id;
        seen[size].available = true;
        seen[size].bestFit = variant.bestFit || seen[size].bestFit || '';
      }
    });

    return uniqueSizes;
  }

function getSizesHtml(product) {
  var uniqueSizes = getUniqueSizes(product.variants);

  if (!uniqueSizes.length) {
    return [
      '<div class="if-mobile-quick-add__label">Size</div>',
      '<p style="font-size:13px;margin:0;">No sizes available</p>'
    ].join('');
  }

  return [
    '<div class="if-mobile-quick-add__label">Size</div>',
    '<div class="if-mobile-quick-add__sizes">',
      uniqueSizes.map(function (item) {
        var bestFitHtml = item.bestFit
          ? '<span class="if-mobile-quick-add__size-best-fit"><strong>Best fit</strong>' + escapeHtml(item.bestFit) + '</span>'
          : '<span class="if-mobile-quick-add__size-best-fit">Best fit unavailable</span>';

        return (
          '<div class="if-mobile-quick-add__size-wrap">' +
            '<button ' +
              'type="button" ' +
              'class="if-mobile-quick-add__size' + (item.available ? '' : ' is-disabled') + '" ' +
              (item.available ? '' : 'disabled ') +
              'data-variant-id="' + (item.available ? escapeAttribute(item.id) : '') + '" ' +
              'data-best-fit="' + escapeAttribute(item.bestFit || '') + '"' +
            '>' +
              escapeHtml(formatSizeLabel(item.size)) +
            '</button>' +
            bestFitHtml +
          '</div>'
        );
      }).join(''),
    '</div>'
  ].join('');
}

  function getDefaultBestFitText(uniqueSizes) {
    var fits = uniqueSizes
      .filter(function (item) {
        return item.available && item.bestFit;
      })
      .map(function (item) {
        return '<strong>' + escapeHtml(formatSizeLabel(item.size)) + ':</strong> ' + escapeHtml(item.bestFit);
      });

    if (!fits.length) {
      return 'Best fit details are not available for this product.';
    }

    return fits.join('<br>');
  }

  function updateBestFit(text) {
    var output = drawer.querySelector('[data-best-fit-output]');

    if (!output) return;

    if (text) {
      output.innerHTML = '<strong>Best fit:</strong> ' + escapeHtml(text);
    } else {
      output.innerHTML = 'Best fit details are not available for this size.';
    }
  }

  function renderDrawer() {
    if (!activeCard) return;

    var data = getQuickAddData(activeCard);
    if (!data) return;

    var activeHandle = selectedHandle || getCurrentHandle(activeCard) || data.currentHandle;
    var product = getQuickAddProduct(data, activeHandle);

    if (!product) return;

    selectedHandle = product.handle;
    selectedVariantId = null;

    var inner = drawer.querySelector('.if-mobile-quick-add__inner');

    inner.innerHTML = [
      '<div class="if-mobile-quick-add__images">',
        getProductImagesHtml(product),
      '</div>',

      '<div class="if-mobile-quick-add__content">',
        '<h3 class="if-mobile-quick-add__title">' + escapeHtml(product.title || '') + '</h3>',

        '<div class="if-mobile-quick-add__price">',
          product.priceHtml || '',
        '</div>',

        getAfterpayHtml(product.priceHtml, ''),

        product.colour
          ? '<p class="if-mobile-quick-add__colour-current"><strong>Colour:</strong><br>' + escapeHtml(product.colour) + '</p>'
          : '',

        getColourHtml(data, product.handle),

        getSizesHtml(product),

        '<button type="button" class="if-mobile-quick-add__add" disabled>',
          'Select a size',
        '</button>',

        getAfterpayHtml(product.priceHtml, 'if-mobile-quick-add__afterpay--bottom'),

        '<a href="' + escapeAttribute(product.url) + '" class="if-mobile-quick-add__details">',
          'View full details',
        '</a>',
      '</div>'
    ].join('');

    bindDrawerActions();
  }

  function bindDrawerActions() {
    drawer.querySelectorAll('.if-mobile-quick-add__size').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.classList.contains('is-disabled')) return;

        drawer.querySelectorAll('.if-mobile-quick-add__size').forEach(function (el) {
          el.classList.remove('is-selected');
        });

        button.classList.add('is-selected');

        selectedVariantId = button.getAttribute('data-variant-id');

        var addButton = drawer.querySelector('.if-mobile-quick-add__add');
        addButton.disabled = false;
        addButton.textContent = 'Add to cart';

        var detailsLink = drawer.querySelector('.if-mobile-quick-add__details');
        if (detailsLink && selectedVariantId) {
          detailsLink.href = detailsLink.href.split('?')[0] + '?variant=' + selectedVariantId;
        }
      });
    });

    drawer.querySelectorAll('.if-mobile-quick-add__colour-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var handle = swatch.getAttribute('data-quick-add-handle');

        if (!handle) return;

        selectedHandle = handle;

        var originalSwatch = activeCard.querySelector('[data-color-swap][data-swap-handle="' + handle + '"]');

        if (originalSwatch) {
          originalSwatch.click();
        } else {
          activeCard.querySelectorAll('[data-pr-href]').forEach(function (link) {
            link.setAttribute('href', '/products/' + handle);
          });
        }

        setTimeout(function () {
          renderDrawer();
        }, 120);
      });
    });

    var addButton = drawer.querySelector('.if-mobile-quick-add__add');

    if (addButton) {
      addButton.addEventListener('click', function () {
        if (!selectedVariantId) return;

        addButton.disabled = true;
        addButton.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(selectedVariantId),
            quantity: 1
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function () {
            addButton.textContent = 'Added';

            refreshCart();

            setTimeout(function () {
              closeDrawer();

              var cartLink = document.querySelector('.t4s-site-nav__cart a[data-drawer-options]');
              if (cartLink) cartLink.click();
            }, 350);
          })
          .catch(function () {
            addButton.disabled = false;
            addButton.textContent = 'Add to cart';
          });
      });
    }
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('t4s:cart:updated', { bubbles: true }));

    fetch('/cart?sections=mini_cart,cart_data&_=' + Date.now(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        if (!sections) return;

        if (sections.mini_cart) {
          var doc = new DOMParser().parseFromString(sections.mini_cart, 'text/html');
          var freshSection = doc.querySelector('#shopify-section-mini_cart');
          var currentSection = document.querySelector('#shopify-section-mini_cart');
          var freshCart = doc.querySelector('#t4s-mini_cart');
          var currentCart = document.querySelector('#t4s-mini_cart');

          if (freshSection && currentSection) {
            currentSection.innerHTML = freshSection.innerHTML;
          } else if (freshCart && currentCart) {
            currentCart.outerHTML = freshCart.outerHTML;
          }
        }

        if (sections.cart_data) {
          var match = sections.cart_data.match(/\[t4s_split1\]([\s\S]*?)\[t4s_split1\]/);

          if (match) {
            var parts = match[1].split('[t4s_split2]');
            var count = parts[0] || '0';
            var priceHtml = parts[1] || '';

            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = count;

              if (parseInt(count, 10) > 0) {
                el.classList.remove('t4s-op-0');
              } else {
                el.classList.add('t4s-op-0');
              }
            });

            document.querySelectorAll('[data-cart-tt-price]').forEach(function (el) {
              el.innerHTML = priceHtml;
            });
          }
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('t4s:cart:updated', { bubbles: true }));
      })
      .catch(function () {});
  }

  function loadFromCard(card) {
    activeCard = card;
    selectedHandle = getCurrentHandle(card);

    if (!selectedHandle) {
      var data = getQuickAddData(card);
      selectedHandle = data && data.currentHandle;
    }

    if (!selectedHandle) return;

    openDrawer();

    drawer.querySelector('.if-mobile-quick-add__inner').innerHTML = [
      '<div class="if-mobile-quick-add__content">',
        'Loading...',
      '</div>'
    ].join('');

    renderDrawer();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.if-mobile-quick-add-btn');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var card = button.closest('.t4s-product');

    if (!card) return;

    loadFromCard(card);
  }, true);
})();